<div
    #navigationStart
    id="root"
    class="flex flex-col h-full"
    tabindex="-1"
    [class]="strings.rootCssClass"
    *ngrxLet="appUser$; let appUser"
>
    <a
        class="fixed top-0 right-[141px] z-[1000] -translate-y-full bg-white px-4 py-3 font-medium transition-transform duration-150 ease-in-out focus:translate-y-0"
        href="#main-content"
        (click)="focusMainContentForAccessibility($event)"
    >
        Skip to main content
    </a>

    <environment-status></environment-status>

    @if (appUser && hasNavigableContent()) {
        <header class="relative flex flex-row">
            <button class="md:hidden" mat-button type="button" aria-label="Toggle sidenav" (click)="sidenav().toggle()">
                <fa-icon [icon]="icons.bars" size="lg"></fa-icon>
            </button>
            <a
                class="absolute left-1/2 flex -translate-x-1/2 items-center justify-center gap-4 md:static md:mr-auto md:translate-x-0 md:justify-start md:grow-0"
                routerLink=""
            >
                <img class="app-logo" src="logo.svg" [alt]="strings.brandName" />
                <span class="app-title hidden md:inline">{{ appTitle }}</span>
            </a>

            <a
                class="header-action ml-auto md:ml-0"
                mat-button
                routerLink="/browse"
                aria-label="Browse pages"
                matTooltip="Browse"
                [matTooltipDisabled]="isHandset$ | async"
            >
                <fa-icon [icon]="icons.compass" size="lg"></fa-icon>
            </a>
            <span class="h-6 w-px bg-current opacity-40" aria-hidden="true"></span>
            <button
                class="header-profile-action"
                mat-button
                [matMenuTriggerFor]="menu"
                aria-label="View profile menu"
                matTooltip="Profile"
                [matTooltipDisabled]="isHandset$ | async"
            >
                <fa-icon [icon]="icons.userCircle" size="lg"></fa-icon>
            </button>
            <mat-menu #menu="matMenu" class="profile-menu">
                <div class="profile clickable flex flex-row">
                    <img class="profile-picture" [src]="appUser.picture" alt="Profile Picture" />
                    <div class="profile-info">
                        <div class="profile-name">{{ appUser.lastName }}, {{ appUser.firstName }}</div>
                        <div class="profile-role">{{ appUser.primaryRole }}</div>
                    </div>
                </div>
                <button mat-menu-item [routerLink]="['/profile']">
                    <fa-icon [icon]="icons.userCircleLight"></fa-icon>
                    Manage Profile
                </button>
                @if (appUser.authSourceType === "database") {
                    <button mat-menu-item (click)="managePassword()">
                        <fa-icon [icon]="icons.lock"></fa-icon>
                        Manage Password
                    </button>
                }

                @if (isImpersonatingUser$ | async) {
                    <button
                        mat-menu-item
                        aria-label="Stop impersonating and return to your account"
                        (click)="stopImpersonating()"
                    >
                        <fa-icon [icon]="icons.rightLeftLarge" aria-hidden="true"></fa-icon>
                        Stop Impersonating
                    </button>
                } @else {
                    <button mat-menu-item (click)="handleLogout()">
                        <fa-icon [icon]="icons.rightFromBracket" aria-hidden="true"></fa-icon>
                        Logout
                    </button>
                }
            </mat-menu>
        </header>
    }

    <mat-sidenav-container class="app-sidenav flex h-full">
        <mat-sidenav
            #sidenavElement
            [opened]="!!appUser && hasNavigableContent() && !(isHandset$ | async)"
            [mode]="(isHandset$ | async) ? 'over' : 'side'"
            [fixedInViewport]="isHandset$ | async"
        >
            @if (appUser && hasNavigableContent()) {
                <div class="flex flex-col h-full">
                    <div class="profile-wrapper flex flex-row items-center place-content-between">
                        <a class="profile clickable flex flex-row items-center" [routerLink]="['/profile']">
                            <img class="profile-picture" [src]="appUser.picture" alt="Profile Picture" />
                            <div class="profile-info">
                                <div class="profile-name">{{ appUser.lastName }}, {{ appUser.firstName }}</div>
                                <div class="profile-role">{{ appUser.primaryRole }}</div>
                            </div>
                        </a>
                        <button
                            type="button"
                            class="close-menu block md:hidden"
                            aria-label="Toggle sidenav"
                            (click)="sidenav().close()"
                        >
                            <fa-icon [icon]="icons.times" size="2x"></fa-icon>
                        </button>
                    </div>

                    <div class="mat-list-wrapper">
                        <app-primary-navigation-menu
                            [items]="primaryNavigationMenu()"
                            (itemActivated)="handleItemActivated()"
                        ></app-primary-navigation-menu>
                    </div>
                </div>
            }
        </mat-sidenav>

        <mat-sidenav-content #mainContent id="main-content" class="view" role="main" tabindex="-1">
            <div id="notification-status" role="status" aria-live="polite" aria-atomic="true">
                @if (messageService.notificationMessage(); as notification) {
                    <div
                        class="block flex-none bg-[#fafbfc] p-2 min-[750px]:fixed min-[750px]:inset-x-0 min-[750px]:top-2 min-[750px]:z-[1000] min-[750px]:flex min-[750px]:justify-center min-[750px]:bg-transparent min-[750px]:p-0"
                        animate.enter="animate-slide-in motion-reduce:animate-none"
                        animate.leave="animate-slide-out motion-reduce:animate-none"
                    >
                        <app-notification-message
                            class="min-[750px]:w-auto min-[750px]:min-w-[344px] min-[750px]:max-w-[672px]"
                            [notification]="notification"
                            [queuedCount]="messageService.queuedCount()"
                            (dismissed)="messageService.dismissMessage()"
                            (dismissAllRequested)="messageService.dismissAllMessages()"
                        ></app-notification-message>
                    </div>
                }
            </div>
            <router-outlet></router-outlet>
        </mat-sidenav-content>
    </mat-sidenav-container>

    <app-loader></app-loader>
</div>
